import Service from './Service';

export default class CityService extends Service{
    constructor() {
        super();
        this.baseURL = 'city';
    }

}